<script setup lang="ts">
import BaseCoreChip from 'frontcore/views/chips/chip/views/base/BaseCoreChip.vue'
import { ChipType } from 'frontcore/views/chips/chip/types'

type Props = {
  deletable?: boolean
  dataTest?: string
  disabled?: boolean
  iconName?: string
  imageSrc?: string
  label: string
  selected: boolean
}
withDefaults(defineProps<Props>(), {
  dataTest: 'core-chip-input',
  deletable: false,
  disabled: false,
  selected: false,
})

type Emits = {
  (e: 'click', event: React.MouseEvent<HTMLElement, MouseEvent>): void
  (e: 'handlerClick', event: React.MouseEvent<HTMLElement, MouseEvent>): void
}
const emit = defineEmits<Emits>()

const onClick = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
  emit('click', event)
}

const onHandlerClick = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
  emit('handlerClick', event)
}
</script>

<template>
  <BaseCoreChip
    :chipType="ChipType.INPUT"
    :deletable="deletable"
    :dataTest="dataTest"
    :disabled="disabled"
    :iconName="iconName"
    :imageSrc="imageSrc"
    :label="label"
    :selected="selected"
    @click="onClick"
    @handlerClick="onHandlerClick" />
</template>
